export default __webpack_public_path__ + "static/media/iconExcelBlack.aaf3f247.svg";